import actionTypes from '../actionTypes';

export function requestGameUrl({ game, isVirtual, isMobile}) {
  return {
    type: actionTypes.GAME_URL_REQUEST,
    value: { game, isVirtual, isMobile },
  };
}

export function successGameUrl(id, url) {
  return {
    type: actionTypes.GAME_URL_SUCCESS,
    value: { id, url },
  };
}

export function failGameUrl(id, e) {
  return {
    type: actionTypes.GAME_URL_FAIL,
    value: id,
    exception: e,
  };
}

export function removeGameUrl(id) {
  return {
    type: actionTypes.GAME_URL_REMOVE,
    value: id,
  };
}
